import React, { useContext } from 'react'

import { CompanyDetailsContext } from 'context/companyDetails'
import { ActivityEndUser } from 'modules/accountActivity/domain'
import { getEndUserDisplayLocation } from 'pages/AccountDetailsPage/utils'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import { MemoReadonlyField } from '../Fields'

import styles from './styles.module.css'

export const convertToNumber = (item: string | undefined): number | undefined => {
  if (item === undefined) {
    return undefined
  }
  const parsed = +item
  return isNaN(parsed) ? undefined : parsed
}

export const prefixUrlWithHttp = (link?: string): string | undefined => {
  if (!link) return link

  const VALID_PREFIXES = ['http://', 'https://', 'mailto:']

  for (const prefix of VALID_PREFIXES) {
    if (link.startsWith(prefix)) {
      return link
    }
  }

  return `http://${link}`
}

export const ContactAboutCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="ContactAboutCardHeader"
      content={
        <div className={styles.headerContent}>
          <div>About</div>
        </div>
      }
      {...rest}
    />
  )
}

export const AboutCard: React.FC<{ contact: ActivityEndUser }> = ({ contact }) => {
  const { companyData } = useContext(CompanyDetailsContext)

  return (
    <BaseCard data-ocweb-id="ContactAboutCard">
      <MemoReadonlyField className={styles.datum} label="Name" value={contact.name} />
      <MemoReadonlyField className={styles.datum} label="Email" value={contact.email} displayWrap />
      <MemoReadonlyField className={styles.datum} label="Role" value={contact.role} />
      <MemoReadonlyField className={styles.datum} label="Company" value={companyData?.name} />
      <MemoReadonlyField
        className={styles.datum}
        label="Location"
        value={getEndUserDisplayLocation(
          contact.locationCity,
          contact.locationStateCode,
          contact.locationCountryCode
        )}
      />
    </BaseCard>
  )
}

export default AboutCard
